import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const HISTORY_SCREEN_URL = 'https://cdn.magicpatterns.com/uploads/ewfaBCybzLDqeprpQncdGH/WhatsApp_Image_2026-07-18_at_10.24.47.jpg';
const SETTLEMENT_SCREEN_URL = 'https://cdn.magicpatterns.com/uploads/62EeCFVoxJKU5XgCXb5v4n/WhatsApp_Image_2026-07-18_at_10.24.47_(1).jpg';
const features = ['Everyone sees who owes what', 'Fair splits, equal or custom', 'The simplest way to settle up', 'Settle up your own way', 'Clear, private group expenses'];
export function ValueProposition() {
  const [activeTab, setActiveTab] = useState<'settlement' | 'history'>('settlement');
  return <section className="py-20 lg:py-28 bg-kitty-yellow-50/50 overflow-hidden" data-id="element-271" data-mp="bo6gpmokv0rs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272" data-mp="bm23uf8parfd">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-273" data-mp="zcz5mz6s88cw">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-274" data-mp="1447jc7f5afvv">
            <p className="text-sm font-semibold text-kitty-yellow-600 uppercase tracking-widest mb-3" data-id="element-275" data-mp="2i9bgqfxkrwk1">
              Full transparency
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-kitty-dark mb-6 leading-tight tracking-tight" data-id="element-276" data-mp="2r8os5e59ev7e">
              Keep every shared expense clear
            </h2>
            <p className="text-lg text-gray-500 mb-8 max-w-md" data-id="element-277" data-mp="30y89ugh8kj0o">
              KittyPot brings every expense, balance and settlement update into
              one shared view, so your group always knows what is owed, pending
              and settled.
            </p>

            <ul className="space-y-4" data-id="element-278" data-mp="39zpn7r39e6lo">
              {features.map((feature, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + index * 0.08
            }} className="flex items-center gap-3" data-id="element-279" data-mp="1kl1fi35m5ctz" data-mpi={index}>
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-kitty-yellow/20 flex items-center justify-center" data-id="element-280" data-mp="3ko2iquyob101">
                    <CheckCircle2 className="w-4 h-4 text-kitty-yellow-700" data-id="element-281" data-mp="3tnfiux0wqd83" />
                  </div>
                  <span className="text-gray-800 font-medium text-base" data-id="element-282" data-mp="2h4nnhikw6oo">
                    {feature}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-283" data-mp="c6oa0x5i2ioa">
            <div className="relative z-10 mx-auto max-w-[390px]" data-id="element-284" data-mp="l51ckrjjyc9n">
              <div className="relative overflow-hidden rounded-[2.25rem] border-[5px] border-kitty-dark bg-kitty-dark shadow-[0_24px_52px_-24px_rgba(27,28,30,0.45)]" data-id="element-285" data-mp="q6z1a1aq1z9z">
                <motion.img src={SETTLEMENT_SCREEN_URL} alt="KittyPot app settlement screen showing member balances" aria-hidden={activeTab !== 'settlement'} animate={{
                opacity: activeTab === 'settlement' ? 1 : 0
              }} transition={{
                duration: 0.22,
                ease: [0.22, 1, 0.36, 1]
              }} className="block h-auto w-full" data-id="element-286" data-mp="25on6j3wwuaby" />
                <motion.img src={HISTORY_SCREEN_URL} alt="KittyPot app history screen showing recorded shared expenses" aria-hidden={activeTab !== 'history'} animate={{
                opacity: activeTab === 'history' ? 1 : 0
              }} transition={{
                duration: 0.22,
                ease: [0.22, 1, 0.36, 1]
              }} className="absolute inset-0 h-full w-full" data-id="element-287" data-mp="2pde34xv9s0ug" />

                <button type="button" onClick={() => setActiveTab('settlement')} aria-pressed={activeTab === 'settlement'} className="absolute left-[5%] top-[23.5%] h-[6.5%] w-[45%] cursor-pointer rounded-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow" aria-label="Show settlement" data-id="element-288" data-mp="38c07clm3282l" />
                <button type="button" onClick={() => setActiveTab('history')} aria-pressed={activeTab === 'history'} className="absolute left-[50%] top-[23.5%] h-[6.5%] w-[45%] cursor-pointer rounded-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow" aria-label="Show expense history" data-id="element-289" data-mp="2iw2ms32qbna6" />
              </div>

              <p className="mt-3 text-center text-xs font-medium text-gray-500" data-id="element-290" data-mp="3fks33oypk7u1">
                The real KittyPot app — settlement and expense history at a glance.
              </p>
            </div>

            {/* Floating notification — outside card to avoid overflow-hidden clipping */}

            {/* Decorative blobs */}
            <div className="absolute top-10 -right-10 w-32 h-32 bg-kitty-yellow-200 rounded-full mix-blend-multiply filter blur-2xl opacity-60" data-id="element-291" data-mp="3uh9e2f2zjkg2" />
            <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-orange-200 rounded-full mix-blend-multiply filter blur-2xl opacity-60" data-id="element-292" data-mp="ciovilts82jz" />
          </motion.div>
        </div>
      </div>
    </section>;
}